import React, { ReactElement } from 'react';
import styles from './passwordChangedPage.module.scss';
import { Title } from '../../../components/title/Title';
import { LoadableButton } from '@mo/loadable-button';
import { useAppContext } from '../../../components/appContext/AppContext';

const PasswordChangedPage: React.FunctionComponent = (): ReactElement | null => {
    const { configState } = useAppContext();
    const buttonText = 'Sign in';
    return (
        <div className={styles.gridContainer}>
            <div className={styles.page}>
                <div className={styles.form}>
                    <div className={styles.formHeader}>
                        <div className={styles.formHeaderContent}>
                            <Title title='Password changed' />
                        </div>
                    </div>
                    <p>Your details have now been updated.</p>
                    <LoadableButton
                        loading={false}
                        loadingText={buttonText}
                        notLoadingText={buttonText}
                        onClick={(): void => window.location.replace(configState.config.pingAccessUrl)}
                        className={styles.signInButton}
                    />
                </div>
            </div>
        </div>
    );
};

export default PasswordChangedPage;
